// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
//
// Ui::* controllers come from the conek_ui engine gem. The gem's public
// entrypoint resolves through the vite alias (the npm package
// @a-safe-digital/conek-ui is not published — the vite config maps it to the
// bundler checkout). Do NOT let stimulus:manifest:update clobber the gem
// registrations below — the local controllers/ui/ directory is gone, so a
// regen cannot reconstruct them.

import { application } from "./application"
import { registerConekUiControllers } from "@a-safe-digital/conek-ui"

// The gem's registration manifest (controllers/ui/index.js) covers ALL of its
// controllers — root-level AND subdirectory (automation/calendar/facilities/
// mobile/observability) — so no host-side Ui::* blocks are needed here. Do not
// re-add them: a host block keeps importing a gem path after the gem renames
// or deletes the file, breaking the host build. The one exception is ui--chart,
// which the gem deliberately keeps OUT of the manifest (see below).
registerConekUiControllers(application)

// conek-ui 0.1.24 moved ui--chart out of the gem's default registration
// manifest into the chart add-on entry (app/javascript/chart.js), so hosts
// without chart pages stop pulling chart.js (~441 KB unminified) into their
// main bundle. The monolith renders Charts::* components in the reporting
// dashboard widgets (packs/reporting), so it registers the controller
// host-side. For THIS host the split is API-compat, not a bundle saving: the
// host's own roi/chart_controller.js already pulls Chart.js into the main
// bundle, and 0.1.23 shipped the same controller class through the default
// manifest — the entry delta is only the tiny add-on module.
import { registerConekUiChartController } from "@conek-ui/app/javascript/chart"
registerConekUiChartController(application)

import Admin__Automation__RuleFormController from "./admin/automation/rule_form_controller"
application.register(
  "admin--automation--rule-form",
  Admin__Automation__RuleFormController,
)

import Admin__Automation__RuleTestController from "./admin/automation/rule_test_controller"
application.register(
  "admin--automation--rule-test",
  Admin__Automation__RuleTestController,
)

import Ai__AgentBuilderFormController from "./ai/agent_builder_form_controller"
application.register("ai--agent-builder-form", Ai__AgentBuilderFormController)

import Ai__AgentRunLiveController from "./ai/agent_run_live_controller"
application.register("ai--agent-run-live", Ai__AgentRunLiveController)

import Ai__AgentRunScrubberController from "./ai/agent_run_scrubber_controller"
application.register("ai--agent-run-scrubber", Ai__AgentRunScrubberController)

import Ai__AgentsGalleryController from "./ai/agents_gallery_controller"
application.register("ai--agents-gallery", Ai__AgentsGalleryController)

// NOTE: identifier stays 'ai--agents--share-form' (double dash between
// 'agents' and 'share-form'). Do not rename — packs/ai/app/views/ai/agents/show.html.erb
// binds data-controller="ai--agents--share-form" plus the matching targets.
// bin/rails stimulus:manifest:update produces a single-dash form that
// breaks the type-select toggle and target lookups.
import Ai__AgentsShareFormController from "./ai/agents_share_form_controller"
application.register("ai--agents--share-form", Ai__AgentsShareFormController)

import Ai__ChatListRailController from "./ai/chat_list_rail_controller"
application.register("ai--chat-list-rail", Ai__ChatListRailController)

import Ai__Companion__AgentPickerController from "./ai/companion/agent_picker_controller"
application.register(
  "ai--companion--agent-picker",
  Ai__Companion__AgentPickerController,
)

import Ai__CompanionContextController from "./ai/companion_context_controller"
application.register("ai--companion-context", Ai__CompanionContextController)

import Ai__CompanionController from "./ai/companion_controller"
application.register("ai--companion", Ai__CompanionController)

import Ai__CompanionSidebarController from "./ai/companion_sidebar_controller"
application.register("ai--companion-sidebar", Ai__CompanionSidebarController)

import Ai__FullPageRailController from "./ai/full_page_rail_controller"
application.register("ai--full-page-rail", Ai__FullPageRailController)

import Ai__JsonInspectorController from "./ai/json_inspector_controller"
application.register("ai--json-inspector", Ai__JsonInspectorController)

import Ai__VectorMapController from "./ai/vector_map_controller"
application.register("ai--vector-map", Ai__VectorMapController)
import Ai__VectorMapPollController from "./ai/vector_map_poll_controller"
application.register("ai--vector-map-poll", Ai__VectorMapPollController)
import Ai__UuidFieldController from "./ai/uuid_field_controller"
application.register("ai--uuid-field", Ai__UuidFieldController)

import Ai__PlaygroundControlsController from "./ai/playground_controls_controller"
application.register(
  "ai--playground-controls",
  Ai__PlaygroundControlsController,
)

import Ai__TextStreamController from "./ai/text_stream_controller"
application.register("ai--text-stream", Ai__TextStreamController)

import Ai__ThinkingOrbController from "./ai/thinking_orb_controller"
application.register("ai--thinking-orb", Ai__ThinkingOrbController)

import Ai__ToolResultChipController from "./ai/tool_result_chip_controller"
application.register("ai--tool-result-chip", Ai__ToolResultChipController)

import Ai__VoiceMemoController from "./ai/voice_memo_controller"
application.register("ai--voice-memo", Ai__VoiceMemoController)

import Auth__EmailFirstLoginController from "./auth/email_first_login_controller"
application.register("auth--email-first-login", Auth__EmailFirstLoginController)

import Bridge__BarcodeController from "./bridge/barcode_controller"
application.register("bridge--barcode", Bridge__BarcodeController)

import Bridge__BottomNavController from "./bridge/bottom_nav_controller"
application.register("bridge--bottom-nav", Bridge__BottomNavController)

import Bridge__CallCaptureController from "./bridge/call_capture_controller"
application.register("bridge--call-capture", Bridge__CallCaptureController)

import Bridge__CallLogController from "./bridge/call_log_controller"
application.register("bridge--call-log", Bridge__CallLogController)

import Bridge__CallObserverController from "./bridge/call_observer_controller"
application.register("bridge--call-observer", Bridge__CallObserverController)

import Bridge__FormGuardController from "./bridge/form_guard_controller"
application.register("bridge--form-guard", Bridge__FormGuardController)

import Bridge__LocationPermissionController from "./bridge/location_permission_controller"
application.register(
  "bridge--location-permission",
  Bridge__LocationPermissionController,
)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NavbarController from "./bridge/navbar_controller"
application.register("bridge--navbar", Bridge__NavbarController)

import Bridge__OfflineQueueController from "./bridge/offline_queue_controller"
application.register("bridge--offline-queue", Bridge__OfflineQueueController)

import Bridge__PushPermissionController from "./bridge/push_permission_controller"
application.register(
  "bridge--push-permission",
  Bridge__PushPermissionController,
)

import Bridge__RecapDictationController from "./bridge/recap_dictation_controller"
application.register(
  "bridge--recap-dictation",
  Bridge__RecapDictationController,
)

import Catalog__AttributeDefinitionFormController from "./catalog/attribute_definition_form_controller"
application.register(
  "catalog--attribute-definition-form",
  Catalog__AttributeDefinitionFormController,
)

import Catalog__AttributeSchemaController from "./catalog/attribute_schema_controller"
application.register(
  "catalog--attribute-schema",
  Catalog__AttributeSchemaController,
)

import Catalog__BranchMatrixController from "./catalog/branch_matrix_controller"
application.register("catalog--branch-matrix", Catalog__BranchMatrixController)

import Catalog__BulkAddController from "./catalog/bulk_add_controller"
application.register("catalog--bulk-add", Catalog__BulkAddController)

import Catalog__BulkOperationsController from "./catalog/bulk_operations_controller"
application.register(
  "catalog--bulk-operations",
  Catalog__BulkOperationsController,
)

import Catalog__BulkSelectController from "./catalog/bulk_select_controller"
application.register("catalog--bulk-select", Catalog__BulkSelectController)

import Catalog__DiffViewerController from "./catalog/diff_viewer_controller"
application.register("catalog--diff-viewer", Catalog__DiffViewerController)

import Catalog__ExportController from "./catalog/export_controller"
application.register("catalog--export", Catalog__ExportController)

import Catalog__ImportWizardController from "./catalog/import_wizard_controller"
application.register("catalog--import-wizard", Catalog__ImportWizardController)

import Catalog__ItemFormController from "./catalog/item_form_controller"
application.register("catalog--item-form", Catalog__ItemFormController)

import Catalog__ItemPickerController from "./catalog/item_picker_controller"
application.register("catalog--item-picker", Catalog__ItemPickerController)

import Catalog__LazyValidationStatusController from "./catalog/lazy_validation_status_controller"
application.register(
  "catalog--lazy-validation-status",
  Catalog__LazyValidationStatusController,
)

import Catalog__LightboxController from "./catalog/lightbox_controller"
application.register("catalog--lightbox", Catalog__LightboxController)

import Catalog__PriceChangeAcknowledgeController from "./catalog/price_change_acknowledge_controller"
application.register(
  "catalog--price-change-acknowledge",
  Catalog__PriceChangeAcknowledgeController,
)

import Catalog__ReplacementForController from "./catalog/replacement_for_controller"
application.register(
  "catalog--replacement-for",
  Catalog__ReplacementForController,
)

import Catalog__RuleTestController from "./catalog/rule_test_controller"
application.register("catalog--rule-test", Catalog__RuleTestController)

import Catalog__SubLineTextDefinitionController from "./catalog/sub_line_text_definition_controller"
application.register(
  "catalog--sub-line-text-definition",
  Catalog__SubLineTextDefinitionController,
)

import Catalog__TranslationEditorController from "./catalog/translation_editor_controller"
application.register(
  "catalog--translation-editor",
  Catalog__TranslationEditorController,
)

import Catalog__TranslationFilterController from "./catalog/translation_filter_controller"
application.register(
  "catalog--translation-filter",
  Catalog__TranslationFilterController,
)

import Catalog__TreeController from "./catalog/tree_controller"
application.register("catalog--tree", Catalog__TreeController)

import Catalog__ValidationErrorsController from "./catalog/validation_errors_controller"
application.register(
  "catalog--validation-errors",
  Catalog__ValidationErrorsController,
)

import ClientTimeController from "./client_time_controller"
application.register("client-time", ClientTimeController)

import Contacts__BusyTriggerController from "./contacts/busy_trigger_controller"
application.register("contacts--busy-trigger", Contacts__BusyTriggerController)

import Contacts__CompanyCreationController from "./contacts/company_creation_controller"
application.register(
  "contacts--company-creation",
  Contacts__CompanyCreationController,
)

import Contacts__CountryOptionsController from "./contacts/country_options_controller"
application.register(
  "contacts--country-options",
  Contacts__CountryOptionsController,
)

import Contacts__CurrencyPositionsController from "./contacts/currency_positions_controller"
application.register(
  "contacts--currency-positions",
  Contacts__CurrencyPositionsController,
)

import Contacts__DrawerResetController from "./contacts/drawer_reset_controller"
application.register("contacts--drawer-reset", Contacts__DrawerResetController)

import Contacts__FormErrorsController from "./contacts/form_errors_controller"
application.register("contacts--form-errors", Contacts__FormErrorsController)

import Contacts__FormatDateController from "./contacts/format_date_controller"
application.register("contacts--format-date", Contacts__FormatDateController)

import Contacts__FormatDatetimeController from "./contacts/format_datetime_controller"
application.register(
  "contacts--format-datetime",
  Contacts__FormatDatetimeController,
)

import Contacts__LanguageSlotsController from "./contacts/language_slots_controller"
application.register(
  "contacts--language-slots",
  Contacts__LanguageSlotsController,
)

import Contacts__NoPostalCodeController from "./contacts/no_postal_code_controller"
application.register(
  "contacts--no-postal-code",
  Contacts__NoPostalCodeController,
)

import Contacts__PersonsDisqualifyController from "./contacts/persons_disqualify_controller"
application.register(
  "contacts--persons-disqualify",
  Contacts__PersonsDisqualifyController,
)

import Contacts__PersonsEmptyFieldsController from "./contacts/persons_empty_fields_controller"
application.register(
  "contacts--persons-empty-fields",
  Contacts__PersonsEmptyFieldsController,
)

import Contacts__PersonsValidateController from "./contacts/persons_validate_controller"
application.register(
  "contacts--persons-validate",
  Contacts__PersonsValidateController,
)

import Contacts__PictureUploadController from "./contacts/picture_upload_controller"
application.register(
  "contacts--picture-upload",
  Contacts__PictureUploadController,
)

import Contacts__PrimaryEmailLockController from "./contacts/primary_email_lock_controller"
application.register(
  "contacts--primary-email-lock",
  Contacts__PrimaryEmailLockController,
)

import Contacts__SubmitGateController from "./contacts/submit_gate_controller"
application.register("contacts--submit-gate", Contacts__SubmitGateController)

import Contacts__TitleSpinnerController from "./contacts/title_spinner_controller"
application.register(
  "contacts--title-spinner",
  Contacts__TitleSpinnerController,
)

import Contacts__TimelineCommentController from "./contacts/timeline_comment_controller"
application.register(
  "contacts--timeline-comment",
  Contacts__TimelineCommentController,
)

import Contacts__TimelineFiltersDraftController from "./contacts/timeline_filters_draft_controller"
application.register(
  "contacts--timeline-filters-draft",
  Contacts__TimelineFiltersDraftController,
)

import Contacts__V2ExternalLinksController from "./contacts/v2_external_links_controller"
application.register(
  "contacts--v2-external-links",
  Contacts__V2ExternalLinksController,
)

import CustomerPortal__FloorplanController from "./customer_portal/floorplan_controller"
application.register(
  "customer-portal--floorplan",
  CustomerPortal__FloorplanController,
)

import Docs__BackToTopController from "./docs/back_to_top_controller"
application.register("docs--back-to-top", Docs__BackToTopController)

import Docs__CodeCopyController from "./docs/code_copy_controller"
application.register("docs--code-copy", Docs__CodeCopyController)

import Docs__FeedbackController from "./docs/feedback_controller"
application.register("docs--feedback", Docs__FeedbackController)

import Docs__LayoutController from "./docs/layout_controller"
application.register("docs--layout", Docs__LayoutController)

import Docs__LightboxController from "./docs/lightbox_controller"
application.register("docs--lightbox", Docs__LightboxController)

import Docs__ScrollSpyController from "./docs/scroll_spy_controller"
application.register("docs--scroll-spy", Docs__ScrollSpyController)

import Docs__SearchController from "./docs/search_controller"
application.register("docs--search", Docs__SearchController)

import Docs__SidebarController from "./docs/sidebar_controller"
application.register("docs--sidebar", Docs__SidebarController)

import Docs__YoutubeController from "./docs/youtube_controller"
application.register("docs--youtube", Docs__YoutubeController)

import Engage__AnnouncementController from "./engage/announcement_controller"
application.register("engage--announcement", Engage__AnnouncementController)

import Engage__BannerController from "./engage/banner_controller"
application.register("engage--banner", Engage__BannerController)

import Engage__ChecklistController from "./engage/checklist_controller"
application.register("engage--checklist", Engage__ChecklistController)

import Engage__NpsController from "./engage/nps_controller"
application.register("engage--nps", Engage__NpsController)

// NOTE: identifier stays 'engage-slug' (single dash). Do not rename —
// packs/engage/app/views/engage/admin/flows/_form.html.erb binds
// data-controller="engage-slug" for the auto-slug-from-name field. The
// pack/name-based double-dash regen breaks slug auto-population.
import Engage__SlugController from "./engage/slug_controller"
application.register("engage-slug", Engage__SlugController)

import Engage__SpotlightController from "./engage/spotlight_controller"
application.register("engage--spotlight", Engage__SpotlightController)

// NOTE: identifier stays 'engage-step-reorder' (single dash). Do not
// rename — packs/engage/app/views/engage/admin/flows/show.html.erb binds
// data-controller="engage-step-reorder" for drag-to-reorder step reindexing.
import Engage__StepReorderController from "./engage/step_reorder_controller"
application.register("engage-step-reorder", Engage__StepReorderController)

import Engage__TooltipController from "./engage/tooltip_controller"
application.register("engage--tooltip", Engage__TooltipController)

import Engage__TourController from "./engage/tour_controller"
application.register("engage--tour", Engage__TourController)

import Errors__CountdownController from "./errors/countdown_controller"
application.register("errors--countdown", Errors__CountdownController)

import Facilities__FloorplanCanvasController from "./facilities/floorplan_canvas_controller"
application.register(
  "facilities--floorplan-canvas",
  Facilities__FloorplanCanvasController,
)

import Facilities__DrawerFrameController from "./facilities/drawer_frame_controller"
application.register(
  "facilities--drawer-frame",
  Facilities__DrawerFrameController,
)

import Facilities__FilterCascadeController from "./facilities/filter_cascade_controller"
application.register(
  "facilities--filter-cascade",
  Facilities__FilterCascadeController,
)

import Facilities__FloorFieldController from "./facilities/floor_field_controller"
application.register(
  "facilities--floor-field",
  Facilities__FloorFieldController,
)

import Facilities__FramePrefetchController from "./facilities/frame_prefetch_controller"
application.register(
  "facilities--frame-prefetch",
  Facilities__FramePrefetchController,
)

import Facilities__DrawerLinkController from "./facilities/drawer_link_controller"
application.register(
  "facilities--drawer-link",
  Facilities__DrawerLinkController,
)

import Facilities__HandleBoundsController from "./facilities/handle_bounds_controller"
application.register(
  "facilities--handle-bounds",
  Facilities__HandleBoundsController,
)

import Facilities__LegPositionController from "./facilities/leg_position_controller"
application.register(
  "facilities--leg-position",
  Facilities__LegPositionController,
)

import Facilities__UserLocationsController from "./facilities/user_locations_controller"
application.register(
  "facilities--user-locations",
  Facilities__UserLocationsController,
)

import Facilities__LocationFilterController from "./facilities/location_filter_controller"
application.register(
  "facilities--location-filter",
  Facilities__LocationFilterController,
)

import Floorplans__BarrierController from "./floorplans/barrier_controller"
application.register("floorplans--barrier", Floorplans__BarrierController)

import Floorplans__CanvasLoadingController from "./floorplans/canvas_loading_controller"
application.register(
  "floorplans--canvas-loading",
  Floorplans__CanvasLoadingController,
)

import Floorplans__DeviceController from "./floorplans/device_controller"
application.register("floorplans--device", Floorplans__DeviceController)

import Floorplans__EditorSidebarController from "./floorplans/editor_sidebar_controller"
application.register(
  "floorplans--editor-sidebar",
  Floorplans__EditorSidebarController,
)

import Floorplans__FloorZonesController from "./floorplans/floor_zones_controller"
application.register(
  "floorplans--floor-zones",
  Floorplans__FloorZonesController,
)

import Floorplans__InfoController from "./floorplans/info_controller"
application.register("floorplans--info", Floorplans__InfoController)

import Floorplans__PdfGesturesController from "./floorplans/pdf_gestures_controller"
application.register(
  "floorplans--pdf-gestures",
  Floorplans__PdfGesturesController,
)

import Floorplans__SubsetsController from "./floorplans/subsets_controller"
application.register("floorplans--subsets", Floorplans__SubsetsController)

import Floorplans__ViewModeController from "./floorplans/view_mode_controller"
application.register("floorplans--view-mode", Floorplans__ViewModeController)

import Identity__BulkRolesController from "./identity/bulk_roles_controller"
application.register("identity--bulk-roles", Identity__BulkRolesController)

import Identity__PermissionCategoryController from "./identity/permission_category_controller"
application.register(
  "identity--permission-category",
  Identity__PermissionCategoryController,
)

import Identity__PermissionsPanelController from "./identity/permissions_panel_controller"
application.register(
  "identity--permissions-panel",
  Identity__PermissionsPanelController,
)

import Identity__RoleAssignmentController from "./identity/role_assignment_controller"
application.register(
  "identity--role-assignment",
  Identity__RoleAssignmentController,
)

import Inspections__DisclaimerController from "./inspections/disclaimer_controller"
application.register(
  "inspections--disclaimer",
  Inspections__DisclaimerController,
)

import Inspections__FocusOnConnectController from "./inspections/focus_on_connect_controller"
application.register(
  "inspections--focus-on-connect",
  Inspections__FocusOnConnectController,
)

import Inspections__MeasurementSliderController from "./inspections/measurement_slider_controller"
application.register(
  "inspections--measurement-slider",
  Inspections__MeasurementSliderController,
)

import Inspections__PagerController from "./inspections/pager_controller"
application.register("inspections--pager", Inspections__PagerController)

import Inspections__PhotoGridController from "./inspections/photo_grid_controller"
application.register(
  "inspections--photo-grid",
  Inspections__PhotoGridController,
)

import Inspections__ScanGateController from "./inspections/scan_gate_controller"
application.register("inspections--scan-gate", Inspections__ScanGateController)

import Inspections__SeverityEngineController from "./inspections/severity_engine_controller"
application.register(
  "inspections--severity-engine",
  Inspections__SeverityEngineController,
)

import Inspections__StickyBelowHeaderController from "./inspections/sticky_below_header_controller"
application.register(
  "inspections--sticky-below-header",
  Inspections__StickyBelowHeaderController,
)

import Iot__AccelSendController from "./iot/accel_send_controller"
application.register("iot--accel-send", Iot__AccelSendController)

import Iot__ChartController from "./iot/chart_controller"
application.register("iot--chart", Iot__ChartController)

import Iot__CompareToggleController from "./iot/compare_toggle_controller"
application.register("iot--compare-toggle", Iot__CompareToggleController)

import Iot__ConfigWizardController from "./iot/config_wizard_controller"
application.register("iot--config-wizard", Iot__ConfigWizardController)

import Iot__DashboardRefreshController from "./iot/dashboard_refresh_controller"
application.register("iot--dashboard-refresh", Iot__DashboardRefreshController)

import Iot__DateRangeLinkController from "./iot/date_range_link_controller"
application.register("iot--date-range-link", Iot__DateRangeLinkController)

import Iot__DigestFormController from "./iot/digest_form_controller"
application.register("iot--digest-form", Iot__DigestFormController)

import Iot__FillHeightController from "./iot/fill_height_controller"
application.register("iot--fill-height", Iot__FillHeightController)

import Iot__FirmwareUploadController from "./iot/firmware_upload_controller"
application.register("iot--firmware-upload", Iot__FirmwareUploadController)

import Iot__GatewayZonePickerController from "./iot/gateway_zone_picker_controller"
application.register(
  "iot--gateway-zone-picker",
  Iot__GatewayZonePickerController,
)

import Iot__LegHistoryFiltersController from "./iot/leg_history_filters_controller"
application.register(
  "iot--leg-history-filters",
  Iot__LegHistoryFiltersController,
)

import Iot__ImpactVisibilityController from "./iot/impact_visibility_controller"
application.register("iot--impact-visibility", Iot__ImpactVisibilityController)

import Iot__LocationCompareToggleController from "./iot/location_compare_toggle_controller"
application.register(
  "iot--location-compare-toggle",
  Iot__LocationCompareToggleController,
)

import Iot__OverrideEditorController from "./iot/override_editor_controller"
application.register("iot--override-editor", Iot__OverrideEditorController)

import Iot__PairingEntryController from "./iot/pairing_entry_controller"
application.register("iot--pairing-entry", Iot__PairingEntryController)

import Iot__PairingFormController from "./iot/pairing_form_controller"
application.register("iot--pairing-form", Iot__PairingFormController)

import Iot__QrScanController from "./iot/qr_scan_controller"
application.register("iot--qr-scan", Iot__QrScanController)

import Iot__ReportExportController from "./iot/report_export_controller"
application.register("iot--report-export", Iot__ReportExportController)

import Iot__SavedReportUsersFilterController from "./iot/saved_report_users_filter_controller"
application.register(
  "iot--saved-report-users-filter",
  Iot__SavedReportUsersFilterController,
)

import Iot__ScheduleFormController from "./iot/schedule_form_controller"
application.register("iot--schedule-form", Iot__ScheduleFormController)

import Iot__ScrollFadeController from "./iot/scroll_fade_controller"
application.register("iot--scroll-fade", Iot__ScrollFadeController)

import Iot__TabsAutoscrollController from "./iot/tabs_autoscroll_controller"
application.register("iot--tabs-autoscroll", Iot__TabsAutoscrollController)

import Maps__PointsController from "./maps/points_controller"
application.register("maps--points", Maps__PointsController)

import Maps__RouteController from "./maps/route_controller"
application.register("maps--route", Maps__RouteController)

import Mcp__DebugController from "./mcp/debug_controller"
application.register("mcp--debug", Mcp__DebugController)

import Mcp__LogEntryController from "./mcp/log_entry_controller"
application.register("mcp--log-entry", Mcp__LogEntryController)

import Mobile__FormValidationController from "./mobile/form_validation_controller"
application.register(
  "mobile--form-validation",
  Mobile__FormValidationController,
)

import Mobile__IosAdvisoryController from "./mobile/ios_advisory_controller"
application.register("mobile--ios-advisory", Mobile__IosAdvisoryController)

import Mobile__SubmitFailureController from "./mobile/submit_failure_controller"
application.register("mobile--submit-failure", Mobile__SubmitFailureController)

import Mobile__QuoteStatusLiveController from "./mobile/quote_status_live_controller"
application.register(
  "mobile--quote-status-live",
  Mobile__QuoteStatusLiveController,
)

import Mobile__TabPrefetchController from "./mobile/tab_prefetch_controller"
application.register("mobile--tab-prefetch", Mobile__TabPrefetchController)

import Observability__AttemptToggleController from "./observability/attempt_toggle_controller"
application.register(
  "observability--attempt-toggle",
  Observability__AttemptToggleController,
)

import Observability__BulkSelectController from "./observability/bulk_select_controller"
application.register(
  "observability--bulk-select",
  Observability__BulkSelectController,
)

import Pipeline__BookingAiController from "./pipeline/booking_ai_controller"
application.register("pipeline--booking-ai", Pipeline__BookingAiController)

import Pipeline__BookingDateAlignmentController from "./pipeline/booking_date_alignment_controller"
application.register(
  "pipeline--booking-date-alignment",
  Pipeline__BookingDateAlignmentController,
)

import Pipeline__BookingDatetimeController from "./pipeline/booking_datetime_controller"
application.register(
  "pipeline--booking-datetime",
  Pipeline__BookingDatetimeController,
)

import Pipeline__BookingStandaloneExitController from "./pipeline/booking_standalone_exit_controller"
application.register(
  "pipeline--booking-standalone-exit",
  Pipeline__BookingStandaloneExitController,
)

import Pipeline__BookingTaskCreateController from "./pipeline/booking_task_create_controller"
application.register(
  "pipeline--booking-task-create",
  Pipeline__BookingTaskCreateController,
)

import Pipeline__CalendarController from "./pipeline/calendar_controller"
application.register("pipeline--calendar", Pipeline__CalendarController)

import Pipeline__MobileCalendarController from "./pipeline/mobile_calendar_controller"
application.register(
  "pipeline--mobile-calendar",
  Pipeline__MobileCalendarController,
)

import Pipeline__OpportunityCreateController from "./pipeline/opportunity_create_controller"
application.register(
  "pipeline--opportunity-create",
  Pipeline__OpportunityCreateController,
)

import Pipeline__ParticipantPickerController from "./pipeline/participant_picker_controller"
application.register(
  "pipeline--participant-picker",
  Pipeline__ParticipantPickerController,
)

import Pipeline__TaskCompanyRecommendationsController from "./pipeline/task_company_recommendations_controller"
application.register(
  "pipeline--task-company-recommendations",
  Pipeline__TaskCompanyRecommendationsController,
)

import Pipeline__TaskFormReloadController from "./pipeline/task_form_reload_controller"
application.register(
  "pipeline--task-form-reload",
  Pipeline__TaskFormReloadController,
)

import Pipeline__TaskTitleAutofillController from "./pipeline/task_title_autofill_controller"
application.register(
  "pipeline--task-title-autofill",
  Pipeline__TaskTitleAutofillController,
)

import Pipeline__UnsavedChangesController from "./pipeline/unsaved_changes_controller"
application.register(
  "pipeline--unsaved-changes",
  Pipeline__UnsavedChangesController,
)

// Ui::Calendar::DayTimelineComponent lives in packs/prospecting until it is
// extracted to conek-ui; its controller keeps the gem's identifier so the
// extraction only moves files.
import Prospecting__DayTimelineController from "./prospecting/day_timeline_controller"
application.register(
  "ui--calendar--day-timeline",
  Prospecting__DayTimelineController,
)

import Prospecting__MapController from "./prospecting/map_controller"
application.register("prospecting--map", Prospecting__MapController)

import Prospecting__PlanController from "./prospecting/plan_controller"
application.register("prospecting--plan", Prospecting__PlanController)

import Prospecting__RevealController from "./prospecting/reveal_controller"
application.register("prospecting--reveal", Prospecting__RevealController)

import Prospecting__SiteSuggestController from "./prospecting/site_suggest_controller"
application.register(
  "prospecting--site-suggest",
  Prospecting__SiteSuggestController,
)

import Prospecting__UpgPanelsController from "./prospecting/upg_panels_controller"
application.register(
  "prospecting--upg-panels",
  Prospecting__UpgPanelsController,
)

import Reporting__DashboardGridController from "./reporting/dashboard_grid_controller"
application.register(
  "reporting--dashboard-grid",
  Reporting__DashboardGridController,
)

import Reporting__YourDayController from "./reporting/your_day_controller"
application.register("reporting--your-day", Reporting__YourDayController)

import Reporting__PrintController from "./reporting/print_controller"
application.register("reporting--print", Reporting__PrintController)

import Roi__ChartController from "./roi/chart_controller"
application.register("roi--chart", Roi__ChartController)

import Roi__ComparisonController from "./roi/comparison_controller"
application.register("roi--comparison", Roi__ComparisonController)

import Roi__InlineEditController from "./roi/inline_edit_controller"
application.register("roi--inline-edit", Roi__InlineEditController)

import Roi__ProductSelectorController from "./roi/product_selector_controller"
application.register("roi--product-selector", Roi__ProductSelectorController)

import Roi__ReportStatusController from "./roi/report_status_controller"
application.register("roi--report-status", Roi__ReportStatusController)

import Roi__TcoCalculatorController from "./roi/tco_calculator_controller"
application.register("roi--tco-calculator", Roi__TcoCalculatorController)

import Roi__ZoneEditorController from "./roi/zone_editor_controller"
application.register("roi--zone-editor", Roi__ZoneEditorController)

import Routing__PlannerController from "./routing/planner_controller"
application.register("routing--planner", Routing__PlannerController)

import ScanResolveController from "./scan_resolve_controller"
application.register("scan-resolve", ScanResolveController)

import ScanUnavailableToastController from "./scan_unavailable_toast_controller"
application.register("scan-unavailable-toast", ScanUnavailableToastController)

import Support__AddTagController from "./support/add_tag_controller"
application.register("support--add-tag", Support__AddTagController)

import Support__AgentProfileSeeAllController from "./support/agent_profile_see_all_controller"
application.register(
  "support--agent-profile-see-all",
  Support__AgentProfileSeeAllController,
)

import Support__BulkActionsController from "./support/bulk_actions_controller"
application.register("support--bulk-actions", Support__BulkActionsController)

import Support__CannedResponseController from "./support/canned_response_controller"
application.register(
  "support--canned-response",
  Support__CannedResponseController,
)

import Support__CatalogFormController from "./support/catalog_form_controller"
application.register("support--catalog-form", Support__CatalogFormController)

import Support__CatalogSearchController from "./support/catalog_search_controller"
application.register(
  "support--catalog-search",
  Support__CatalogSearchController,
)

import Support__CategoryPickerController from "./support/category_picker_controller"
application.register(
  "support--category-picker",
  Support__CategoryPickerController,
)

import Support__ChangeCalendarController from "./support/change_calendar_controller"
application.register(
  "support--change-calendar",
  Support__ChangeCalendarController,
)

import Support__ChangeScheduleController from "./support/change_schedule_controller"
application.register(
  "support--change-schedule",
  Support__ChangeScheduleController,
)

import Support__CiLinkController from "./support/ci_link_controller"
application.register("support--ci-link", Support__CiLinkController)

import Support__ConversationSortController from "./support/conversation_sort_controller"
application.register(
  "support--conversation-sort",
  Support__ConversationSortController,
)

import Support__FileDropzoneController from "./support/file_dropzone_controller"
application.register("support--file-dropzone", Support__FileDropzoneController)

import Support__FormSchemaEditorController from "./support/form_schema_editor_controller"
application.register(
  "support--form-schema-editor",
  Support__FormSchemaEditorController,
)

import Support__InboxFiltersController from "./support/inbox_filters_controller"
application.register("support--inbox-filters", Support__InboxFiltersController)

import Support__InboxSidebarController from "./support/inbox_sidebar_controller"
application.register("support--inbox-sidebar", Support__InboxSidebarController)

import Support__InlineEditController from "./support/inline_edit_controller"
application.register("support--inline-edit", Support__InlineEditController)

import Support__JiraLinkController from "./support/jira_link_controller"
application.register("support--jira-link", Support__JiraLinkController)

import Support__KanbanController from "./support/kanban_controller"
application.register("support--kanban", Support__KanbanController)

import Support__KbEditorController from "./support/kb_editor_controller"
application.register("support--kb-editor", Support__KbEditorController)

import Support__KbFeedbackController from "./support/kb_feedback_controller"
application.register("support--kb-feedback", Support__KbFeedbackController)

import Support__KbSearchController from "./support/kb_search_controller"
application.register("support--kb-search", Support__KbSearchController)

import Support__KbSuggestController from "./support/kb_suggest_controller"
application.register("support--kb-suggest", Support__KbSuggestController)

import Support__KeyboardShortcutsController from "./support/keyboard_shortcuts_controller"
application.register(
  "support--keyboard-shortcuts",
  Support__KeyboardShortcutsController,
)

import Support__LiveUpdatesController from "./support/live_updates_controller"
application.register("support--live-updates", Support__LiveUpdatesController)

import Support__MacroDropdownController from "./support/macro_dropdown_controller"
application.register(
  "support--macro-dropdown",
  Support__MacroDropdownController,
)

import Support__MacroFormController from "./support/macro_form_controller"
application.register("support--macro-form", Support__MacroFormController)

import Support__MentionTrackerController from "./support/mention_tracker_controller"
application.register(
  "support--mention-tracker",
  Support__MentionTrackerController,
)

import Support__MergeTicketController from "./support/merge_ticket_controller"
application.register("support--merge-ticket", Support__MergeTicketController)

import Support__PdfPreviewController from "./support/pdf_preview_controller"
application.register("support--pdf-preview", Support__PdfPreviewController)

import Support__PresenceController from "./support/presence_controller"
application.register("support--presence", Support__PresenceController)

import Support__PriorityMatrixController from "./support/priority_matrix_controller"
application.register(
  "support--priority-matrix",
  Support__PriorityMatrixController,
)

import Support__ProblemBrowserController from "./support/problem_browser_controller"
application.register(
  "support--problem-browser",
  Support__ProblemBrowserController,
)

import Support__ProblemLinkController from "./support/problem_link_controller"
application.register("support--problem-link", Support__ProblemLinkController)

import Support__ReactionsController from "./support/reactions_controller"
application.register("support--reactions", Support__ReactionsController)

import Support__ReplyBoxController from "./support/reply_box_controller"
application.register("support--reply-box", Support__ReplyBoxController)

import Support__ResetFormController from "./support/reset_form_controller"
application.register("support--reset-form", Support__ResetFormController)

import Support__ResolutionSuggestionController from "./support/resolution_suggestion_controller"
application.register(
  "support--resolution-suggestion",
  Support__ResolutionSuggestionController,
)

import Support__SavedViewsController from "./support/saved_views_controller"
application.register("support--saved-views", Support__SavedViewsController)

import Support__SelectedTicketController from "./support/selected_ticket_controller"
application.register(
  "support--selected-ticket",
  Support__SelectedTicketController,
)

import Support__SidebarSectionController from "./support/sidebar_section_controller"
application.register(
  "support--sidebar-section",
  Support__SidebarSectionController,
)

import Support__SkillEditorController from "./support/skill_editor_controller"
application.register("support--skill-editor", Support__SkillEditorController)

import Support__SlaTimerController from "./support/sla_timer_controller"
application.register("support--sla-timer", Support__SlaTimerController)

import Support__SnoozeDropdownController from "./support/snooze_dropdown_controller"
application.register(
  "support--snooze-dropdown",
  Support__SnoozeDropdownController,
)

import Support__TagAutocompleteController from "./support/tag_autocomplete_controller"
application.register(
  "support--tag-autocomplete",
  Support__TagAutocompleteController,
)

import Support__TagScopeController from "./support/tag_scope_controller"
application.register("support--tag-scope", Support__TagScopeController)

import Support__TicketFilterCascadeController from "./support/ticket_filter_cascade_controller"
application.register(
  "support--ticket-filter-cascade",
  Support__TicketFilterCascadeController,
)

import Support__TicketFilterController from "./support/ticket_filter_controller"
application.register("support--ticket-filter", Support__TicketFilterController)

import Support__TicketStatusController from "./support/ticket_status_controller"
application.register("support--ticket-status", Support__TicketStatusController)

import Support__TicketTypeToggleController from "./support/ticket_type_toggle_controller"
application.register(
  "support--ticket-type-toggle",
  Support__TicketTypeToggleController,
)

import Support__TicketWizardController from "./support/ticket_wizard_controller"
application.register("support--ticket-wizard", Support__TicketWizardController)

import Support__TriagePollController from "./support/triage_poll_controller"
application.register("support--triage-poll", Support__TriagePollController)

import Support__WeeklyHoursEditorController from "./support/weekly_hours_editor_controller"
application.register(
  "support--weekly-hours-editor",
  Support__WeeklyHoursEditorController,
)

import Telephony__CallInsightController from "./telephony/call_insight_controller"
application.register(
  "telephony--call-insight",
  Telephony__CallInsightController,
)

import TzDetectionController from "./tz_detection_controller"
application.register("tz-detection", TzDetectionController)

// PDF Viewer (from stimulus-pdf-viewer package). Not a file-based controller;
// bin/rails stimulus:manifest:update does NOT regenerate this — preserve manually.
// Consumed by packs/support/app/views/support/shared/_pdf_preview_modal.html.erb
// (data-controller="pdf-viewer"). CONEK-5212: a previous regen dropped this
// registration and broke every quote PDF preview in production; the
// bin/rails stimulus:check_manifest_integrity CI ratchet exists specifically
// to catch that regression again.
import { PdfViewerController } from "stimulus-pdf-viewer"
application.register("pdf-viewer", PdfViewerController)
